"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var typestyle_1 = require("typestyle");
var InputEstimate = function (props) {
    var base = "TripleEstimatesForm__Input";
    var invalidClass = props.invalid ? "Input--Invalid" : null;
    var inputClasses = (0, typestyle_1.classes)(base, invalidClass, "form-control");
    return (React.createElement("input", { className: inputClasses, type: "text", name: props.name, value: props.value, onChange: props.change }));
};
exports.default = InputEstimate;
